import { FC, SVGProps } from 'react';

export const BlockedIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="7.99998" cy="8.50016" r="6.66667" stroke={props.stroke || '#fc7070'} strokeWidth="1.3" />
    <path d="M11 3.5L5 13.5" stroke={props.stroke || '#fc7070'} strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);
